import * as React from "react";
import { useContext, useRef } from "react";
import { styled, css, ThemeProvider } from "styled-components";
import { Colors, mediaQueries } from "../../styles";
import { StyledH3 } from "../Text/headers/styles";
import AccordionContext from "./AccordionContext";
import { ChevronDown } from "../../icons";
import { rem } from "../../utils/rem";
import { InputText } from "../Text";
import { Check } from "../../icons";
import idGenerator from "../../utils/idGenerator";
const StyledAccordionItem = styled.div `
  display: flex;
  flex-direction: column;

  &:last-child {
    border-bottom: 1.12px solid ${Colors.GRAY};
  }
  ${({ theme }) => ["panel", "radio", "checkbox", "checkBoxAsRadio"].indexOf(theme?.name) !==
    -1 &&
    css `
      border-top: none;
      &:last-child {
        border-bottom: none;
      }
      margin-bottom: ${rem(16)};
    `}
`;
const H3Wrapper = styled.h3 `
  margin: 0;
  padding: 0;
`;
const StyledAccordionToggle = styled(StyledH3) `
  appearance: none;
  display: flex;
  flex: 1;
  border: 0;
  background: transparent;
  padding: ${rem(12)} 0 ${rem(18)};
  margin: 0;
  width: 100%;
  cursor: pointer;
  text-align: left;
  align-items: flex-start;

  @media (hover: hover) {
    &:hover {
      background-color: ${Colors.GRAY_LIGHT};
    }
  }

  justify-content: space-between;
  > svg {
    width: ${rem(15)};
    height: ${rem(15)};
    transition: all 0.2s ease;
    margin-right: ${rem(8)};
    margin-left: ${rem(10)};
    flex-shrink: 0;
    margin-top: ${rem(8)};
  }
  &[aria-expanded="true"] {
    > svg {
      width: ${rem(15)};
      transform: rotateZ(-180deg);
    }
  }
  > span {
    display: flex;
    flex-wrap: wrap;
  }

  ${mediaQueries.up("medium") `
    padding: ${rem(16)} 0 ${rem(18)};
  `}

  ${({ theme, active, black_friday_theme }) => ["panel", "radio", "checkbox", "checkBoxAsRadio"].indexOf(theme?.name) !==
    -1 &&
    css `
      background-color: ${theme.HEADER_BG};
      
      border: 1px solid ${Colors.GRAY};
      border-radius: 4px;
      padding: ${rem(16)} ${rem(20)} ${rem(16)} ${rem(20)};

      &[aria-expanded="true"] {
        border-radius: 4px 4px 0 0;
      }
      > svg {
        stroke: ${theme.CHEVRON_COLOR};
      }
      &:hover {
        background-color: ${Colors.GRAY_LIGHT_DISABLED};
      }
      ${active &&
        css `
        background-color: ${black_friday_theme ? Colors.BLACK_2024 : Colors.LIGHT_RED_2024};
        border: 1px solid ${Colors.LIGHT_RED_2024};
        

        &:hover {
          background-color: ${black_friday_theme ? '#22222293' : Colors.LIGHT_RED_2024};
          
        }
      `}

      ${mediaQueries.up("medium") `
        padding: ${rem(16)} ${rem(20)} ${rem(16)} ${rem(20)};
      `}
    `}
`;
const Content = styled.div `
  max-height: 0;
  transition: max-height 0.1s ease-out;
  overflow: hidden;
  box-sizing: border-box;
  

  &[aria-expanded="true"] {
    max-height: 705vh;
    transition: max-height 0.1s ease-in;

    ${mediaQueries.down("large") `
      max-height: 705vh;
    `}
    ${mediaQueries.down("belowSmall") `
      max-height: 786vh;
    `}
  }
`;
const ContentWrapper = styled.div `
  ${({ theme }) => ["panel", "radio", "checkbox", "checkBoxAsRadio"].indexOf(theme?.name) !==
    -1 &&
    css `
      border-right: 1px solid ${Colors.GRAY};
      border-left: 1px solid ${Colors.GRAY};
      border-bottom: 1px solid ${Colors.GRAY};

      border-radius: 0 0 5px 5px;
      padding: ${rem(20)} ${rem(30)};
      ${['radio', 'checkbox', 'checkBoxAsRadio'].indexOf(theme?.name) !== -1 &&
        mediaQueries.up('medium') `
          padding: ${rem(16)} ${rem(16)};
        `}

      /* ${theme?.name === 'panel' &&
        mediaQueries.up('medium') `
      padding: ${rem(16)} ${rem(16)};
        `} */
    `}
`;
const StyledFooter = styled.div `
  background: ${Colors.GRAY_LIGHT};
  border: 1px solid ${Colors.GRAY};
  box-sizing: border-box;
  border-radius: 0 0 4px 4px;
  padding: ${rem(20)} ${rem(42)};
  border-top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
`;
const variants = {
    panel: {
        name: "panel",
        HEADER_BG: Colors.GRAY_LIGHT,
        CHEVRON_COLOR: Colors.BLACK,
    },
    radio: {
        name: "radio",
        HEADER_BG: Colors.GRAY_LIGHT,
        CHEVRON_COLOR: Colors.BLACK,
    },
    checkbox: {
        name: "checkbox",
        HEADER_BG: Colors.GRAY_LIGHT,
        CHEVRON_COLOR: Colors.BLACK,
    },
    checkBoxAsRadio: {
        name: "checkBoxAsRadio",
        HEADER_BG: Colors.GRAY_LIGHT,
        CHEVRON_COLOR: Colors.BLACK,
    },
};
const SubTitle = styled.span `
  color: ${Colors.BLACK_2024};
  margin-left: ${rem(16)};
  font-weight: normal;
  line-height: 1.4;
  
`;
const getTitleComponent = (variant, { title, values, onChange, name, value, itemId, subTitle, nonInteractiveArea, black_friday_theme, isActive }) => {
    switch (variant) {
        case "radio":
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { ref: nonInteractiveArea },
                    React.createElement(RadioButton, { checked: itemId === value, label: title, name: name, onChange: () => {
                            if (onChange) {
                                onChange(itemId);
                            }
                        }, value: itemId })),
                React.createElement(SubTitle, { style: { color: isActive && black_friday_theme ? 'white' : '' } }, subTitle)));
        case "checkbox":
            return (React.createElement("span", { ref: nonInteractiveArea },
                React.createElement(Checkbox, { label: React.createElement("span", { style: { color: isActive && black_friday_theme ? 'white' : '' } },
                        title,
                        " ",
                        React.createElement(SubTitle, { style: { color: isActive && black_friday_theme ? 'white' : '' } }, subTitle)), name: name, checked: values.indexOf(itemId) !== -1, onChange: () => {
                        if (onChange) {
                            onChange(itemId);
                        }
                    } })));
        case "checkBoxAsRadio":
            return (React.createElement("span", { ref: nonInteractiveArea },
                React.createElement(RadioButton, { label: React.createElement("span", { style: { color: isActive && black_friday_theme ? 'white' : '' } },
                        title,
                        " ",
                        React.createElement(SubTitle, { style: { color: isActive && black_friday_theme ? 'white' : '' } }, subTitle)), name: Math.random().toString(), checked: values.indexOf(itemId) !== -1, onClick: () => {
                        if (onChange) {
                            onChange(itemId);
                        }
                    }, readOnly: true })));
        default:
            return (React.createElement(React.Fragment, null,
                title,
                subTitle && React.createElement(SubTitle, { style: { color: isActive && black_friday_theme ? 'white' : '' } }, subTitle)));
    }
};
export const AccordionItem = React.forwardRef(({ children, itemId, title, subTitle, footer, name, "data-cy": testId, black_friday_theme }, ref) => {
    const { openedItems, onToggle, variant, accordionId, value, values, onChange, } = useContext(AccordionContext);
    const idControl = `${accordionId}-${itemId}`;
    const idContent = `${accordionId}-content-${itemId}`;
    const theme = variant ? variants[variant] : null;
    const buttonRef = useRef(null);
    const nonInteractiveArea = useRef(null);
    const onToggleClick = (event) => {
        if (event.target instanceof Node &&
            nonInteractiveArea?.current?.contains(event.target)) {
            return;
        }
        onToggle(itemId);
    };
    const isActive = itemId === value || values.indexOf(itemId) !== -1;
    return (React.createElement(ThemeProvider, { theme: theme || {} },
        React.createElement(StyledAccordionItem, { "data-cy": testId, ref: ref },
            React.createElement(H3Wrapper, null,
                React.createElement(StyledAccordionToggle, { black_friday_theme: black_friday_theme, ref: buttonRef, as: "button", id: idControl, active: isActive, "aria-expanded": openedItems.indexOf(itemId) !== -1, "aria-controls": idContent, onClick: onToggleClick },
                    React.createElement("span", null, getTitleComponent(variant, {
                        onChange,
                        black_friday_theme,
                        values,
                        itemId,
                        name,
                        title,
                        value,
                        nonInteractiveArea,
                        subTitle,
                        isActive,
                    })),
                    React.createElement(ChevronDown, null))),
            React.createElement(Content, { id: idContent, "aria-labelledby": idControl, "aria-expanded": openedItems.indexOf(itemId) !== -1 },
                React.createElement(ContentWrapper, null, children),
                footer && React.createElement(StyledFooter, null, footer)))));
});
export default AccordionItem;
const CheckboxLabel = styled.label `
  position: relative;
  display: flex;
  align-items: flex-start;
  cursor: pointer;

  &:hover > input,
  &:hover > input:checked {
    box-shadow: inset 0 0 0 1px ${Colors.WHITE_2024},
      0 0 0 4px ${Colors.LIGHT_RED_2024};
  }

  > input {
    flex-shrink: 0;
    appearance: none;
    border: none;
    padding: 0;
    margin: 0 0.5rem 0 0;
    width: 1.5rem;
    height: 1.5rem;
    box-shadow: inset 0 0 0 1px ${Colors.GRAY};
    border-radius: 0.25rem;
    cursor: pointer;

    + span {
      margin-top: 1px;
    }

    ~ span > svg {
      position: absolute;
      top: 0.25rem;
      left: 0.25rem;
      visibility: hidden;
    }

    &:checked {
      background-color: ${Colors.WHITE_2024};
      box-shadow: inset 0 0 0 1px ${Colors.WHITE_2024};

      ~ span > svg {
        visibility: visible;
      }
    }
  }
`;
const Checkbox = ({ label, ...props }) => {
    const [inputId] = React.useState(() => props.id ?? idGenerator("fjordline-radio-"));
    return (React.createElement(CheckboxLabel, { htmlFor: inputId },
        React.createElement("input", { type: "checkbox", id: inputId, ...props }),
        React.createElement(InputText, null, label),
        React.createElement("span", { "aria-hidden": "true" },
            React.createElement(Check, { width: 16, height: 16 }))));
};
const StyledRadioButton = styled.label `
  display: flex;
  align-items: center;
  ${({ hasIcon }) => hasIcon &&
    css `
      position: relative;
      padding: 1rem;
    `}

  &,
  > * {
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  }

  &:hover {
    > input:not(:disabled),
    > input:not(:disabled):checked {
      box-shadow: inset 0 0 0 1px ${Colors.PROFILE_RED_2024},
        0 0 0 4px ${Colors.LIGHT_RED_2024};

      &,
      + div[aria-hidden="true"] {
        background-color: ${Colors.WHITE};
      }

      + div[aria-hidden="true"] {
        background-color: ${Colors.LIGHT_RED_2024};
        box-shadow: inset 0 0 0 1px ${Colors.WHITE_2024};
      }
    }
  }

  > input {
    position: relative;
    appearance: none;
    border: none;
    padding: 0;
    margin: ${({ hasIcon }) => (hasIcon ? "0" : "0 0.75rem 0 0")};
    width: 1.6rem;
    height: 1.6rem;
    min-width: 1.6rem;
    min-height: 1.6rem;
    border-radius: 50%; /* Make the input a circle */
    box-shadow: inset 0 0 0 1px ${Colors.GRAY};

    + div[aria-hidden="true"] {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 0.8rem;
      height: 0.8rem;
      pointer-events: none;
      border-radius: 50%; /* Make it a circle */
      z-index: -1;
      ${({ isChecked }) => isChecked &&
    css `
          background: ${Colors.LIGHT_RED_2024};
        `}
    }

    &:not(:disabled) {
      &:checked {
        box-shadow: inset 0 0 0 2px ${Colors.WHITE_2024};

        &:hover {
          background: ${Colors.LIGHT_RED_2024};
          box-shadow: inset 0 0 0 2px ${Colors.WHITE_2024};
        }
      }

      + div[aria-hidden="true"] {
        box-shadow: inset 0 0 0 2px ${Colors.WHITE_2024};
      }
    }

    &::after {
      position: absolute;
      content: "";
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 0.6rem;
      height: 0.6rem;
      border-radius: 50%; /* Make it a circle */
      background-color: ${Colors.WHITE_2024};
      transition: background-color 0.2s ease;
      opacity: 0;
    }

    &:checked::after {
      opacity: 1;
    }

    &:disabled {
      opacity: 0.5;

      + div[aria-hidden="true"] {
        background-color: ${Colors.GRAY};
        box-shadow: inset 0 0 0 2px ${Colors.GRAY};
      }

      ~ ${InputText.toString()} {
        color: ${Colors.GRAY};
      }
    }
  }

  ${InputText.toString()} {
    position: relative;
    top: 1px;
  }
`;
const IconContainer = styled.span `
  margin: 0 0.625rem;

  svg {
    display: block;
  }
`;
const RadioButton = ({ id, label, title, disabled, icon: Icon, ...props }) => {
    const [inputId] = React.useState(() => id || idGenerator("fjordline-radio-"));
    const inputRef = React.useRef(null);
    return (React.createElement(StyledRadioButton, { title: title, hasIcon: !!Icon, isDisabled: disabled ?? false, isChecked: inputRef.current?.checked ?? false, htmlFor: inputId },
        React.createElement("input", { id: inputId, type: "radio", title: title, disabled: disabled, ref: inputRef, ...props }),
        Icon && (React.createElement(React.Fragment, null,
            React.createElement("div", { "aria-hidden": "true" }),
            React.createElement(IconContainer, null,
                React.createElement(Icon, { width: 24, height: 24 })))),
        label && React.createElement(InputText, null, label)));
};
//# sourceMappingURL=AccordionItem.js.map